import React, { useContext } from "react";
import { Button, Col, Row, Spin } from "antd";
import ShiftRecord from "../ShiftRecord";
import AsideBlock from "../../../components/AsideBlock";
import { InvigilationCtx } from "../../../context";
import { getExamStudentLeaveScreenInfo } from "../../../../../../service/exam";
import styles from "../../../camCaptureRecord/index.module.scss";
import ShiftModal from "../ShiftModal";
import useExamInfo from "../../../Hook/useExamInfo";
import useModalHandler from "../../../../../../utils/v2/useModalHandler";

export default function AsideShift() {
    const { currentData } = useContext(InvigilationCtx);
    const shiftModal = useModalHandler(ShiftModal, { remove: true });

    const [data, { loading }] = useExamInfo(
        getExamStudentLeaveScreenInfo,
        currentData
    );

    function openModal() {
        shiftModal.open(currentData);
    }

    return (
        <AsideBlock
            title="切屏记录"
            count={data?.leaveScreenList.length}
            extra={
                <Button
                    type="link"
                    className={styles.button}
                    onClick={openModal}>
                    查看更多&gt;
                </Button>
            }>
            <Spin spinning={loading}>
                <Row type="flex">
                    {data?.leaveScreenList?.slice(0, 6).map((item, index) => (
                        <Col key={index} span={8}>
                            <ShiftRecord {...item} />
                        </Col>
                    ))}

                    {data?.leaveScreenList?.length === 0 && (
                        <Col span={24}>无切屏记录</Col>
                    )}
                </Row>
            </Spin>

            {shiftModal.render(
                <ShiftModal data={data?.leaveScreenList || []} />
            )}
        </AsideBlock>
    );
}
